import { useState } from 'react';

import { Alert } from '@zooplus/ui-components';

import BaseModal from '../BaseModal/BaseModal';
import styles from '../BaseModal/BaseModal.module.scss';

import CreditCardNew from '@components/CreditCardNew/CreditCardNew';
import { useTranslation } from '@hooks/useTranslations';
import { useCreditCardContext } from '@providers/CreditCardContextProvider';
import { OverlayIds, useOverlays } from '@providers/OverlaysProvider';

/**
 * Modal to make the customer confirms that he really wants to delete the given stored credit card.
 * Independent from the actual payment service provider.
 */
const DeleteCardModalNew = () => {
  const { t } = useTranslation();
  const { cardToDelete, deleteHandler } = useCreditCardContext();
  const [deleteCardError, setDeleteCardError] = useState<string>();
  const [deleteCardLoading, setDeleteCardLoading] = useState(false);
  const { hideOverlay } = useOverlays();

  if (!cardToDelete) return null;

  const handleDeleteCard = () => {
    setDeleteCardLoading(true);
    setDeleteCardError(undefined);
    deleteHandler?.();
    hideOverlay(OverlayIds.DELETE_CARD_NEW);
    setDeleteCardLoading(false);
  };

  return (
    <BaseModal
      modalId={OverlayIds.DELETE_CARD_NEW}
      disabledDangerBtn={deleteCardLoading}
      disabledSecondaryBtn={deleteCardLoading}
      isLoading={deleteCardLoading}
      handleSubmit={handleDeleteCard}
      heading={t('checkout.payment.creditcard.delete.heading')}
      dangerButtonLabel={t('checkout.payment.creditcard.delete.button')}
      headingId={`delete-card-${cardToDelete?.pspIdentifier}`}
      closeBtnAriaLabel={t('checkout.payment.creditcard.delete.heading')}
      dataZta="modal-removeCard"
      size="sm">
      {deleteCardError && (
        <Alert className={styles.errorMessage} variant="warning">
          {deleteCardError}
        </Alert>
      )}
      <div className={styles.confirmDeleteMessage}>
        {t('checkout.payment.creditcard.delete.text')}
      </div>
      <div className={styles.confirmDeleteCardContainer}>
        {cardToDelete && <CreditCardNew creditCard={cardToDelete} />}
      </div>
    </BaseModal>
  );
};

export default DeleteCardModalNew;
